export default 
[
  {
    id: 0,
    nome: ''
  },
  {
    id: 1,
    nome: 'Pessoa Física'
  },
  {
    id: 2,
    nome: 'Pessoa Jurídica'
  },
]



// WEBPACK FOOTER //
// ./FrontEnd/js/tipos-pessoa-conta.js